import { useEffect, useRef, useCallback } from "react";

export function useLocalDraft(key) {
  const timeoutRef = useRef(null);

  const restore = useCallback(() => {
    try {
      const raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, [key]);

  const save = useCallback(
    (data) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        try {
          localStorage.setItem(key, JSON.stringify(data));
        } catch {
          /* quota exceeded — ignore */
        }
      }, 500);
    },
    [key]
  );

  const clear = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    sessionStorage.removeItem(key);
  }, [key]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return { restore, save, clear };
}
